import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../components/confirmation-dialog/confirmation-dialog.component';
import {take} from 'rxjs/operators';

interface ConfirmParams {
    onSuccess;
    onDismiss?;
    message?: string;
    title?: string;
}


@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {

    constructor(private dialog: MatDialog) {
    }

    confirm({onSuccess, onDismiss, message, title}: ConfirmParams) {
        const config: MatDialogConfig = {
            autoFocus: false
        };
        if (message || title) {
            config.data = {message, title};
        }
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
        dialogRef.afterClosed()
            .pipe(take(1))
            .subscribe(async resp => {
                if (resp) {
                    onSuccess();
                } else if (onDismiss) {
                    onDismiss();
                }
            });
    }
}
